import React, { useMemo } from 'react';
import { Flex, IntrinsicImage, Text } from '@tishman/components';
import { ThemeUIStyleObject } from 'theme-ui';

import { usePageData } from '../../../../utils';
import { flowToSanityTicketMap } from '../../../../blocks/Cart/utils';

import type { CartContentTranslationsForFlow } from '../../../../data/translations/cartContent';
import type { Flow } from '../../../../services/viva/constants';

type Props = {
  children?: React.ReactNode;
  translations?: CartContentTranslationsForFlow;
  flow?: Flow;
  sx?: ThemeUIStyleObject;
};

export const TicketGroup = ({ children, translations, flow, sx }: Props) => {
  const { sanityContentForCart } = usePageData<Queries.CartQuery>();

  const image = useMemo(() => {
    if (!flow || !sanityContentForCart?.nodes) return null;

    const buyTicketsKey = flowToSanityTicketMap[flow];
    const attraction = sanityContentForCart.nodes.find(
      (i) => i.slug?.current === buyTicketsKey,
    );

    return attraction?.tickets?.[0]?.image;
  }, [flow, sanityContentForCart]);

  if (!translations) return null;

  return (
    <Flex
      sx={{
        ...sx,
        flexDirection: 'column',
        rowGap: [2],
      }}
    >
      {image?.asset && (
        <IntrinsicImage
          alt={image.alt ?? ''}
          image={image.asset.gatsbyImageData}
          sx={{
            aspectRatio: '343 / 152',
          }}
        />
      )}
      <Text
        sx={{
          fontSize: ['18px'],
          fontWeight: 500,
        }}
      >
        {translations.title}
      </Text>
      <Flex
        sx={{
          flexDirection: 'column',
        }}
      >
        <Flex
          sx={{
            flexDirection: 'column',
            rowGap: ['8px'],
          }}
        >
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};
